import React from 'react';

interface CircleIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const FaCheck: React.FC<CircleIconProps> = ({  ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.5 9.75271L7.77473 15.0274L17.5 4.97257"
      stroke={props.color ?? props?.style?.color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FaCheck;
